import { MenuItem } from '@mui/joy';
import { PropsWithChildren, ReactElement } from 'react';

interface IMenuItemProps {
  id?: string;
  linkTo: string;
  target?: string;
  className?: string;
}

export const DropdownExternalLinkItem = ({ id, linkTo, target, className, children }: PropsWithChildren<IMenuItemProps>): ReactElement => {
  const handleClick = (): void => {
    window.open(linkTo, target || '_blank');
  };
  return (
    <a
      onClick={handleClick}
      className={className}
    >
      <MenuItem id={id}>{children}</MenuItem>
    </a>
  );
};
